import Paths from "router/Paths";
import {
   HomeSvg, DeviceMessageSvg, DocumentCopySvg, EditSvg,
   GlobeSvg, LogoutSvg, NoteSvg, SettingSvg, TargetSvg,
   UserGroupSvg
} from "svg/icons";

export default [
   {
      path: Paths.Home,
      title: "Home",
      svg: <HomeSvg/>
   },
   {
      path: Paths.TerritorialUnits,
      title: "Lista jednostek terytorialnych",
      allowed_role: [ "admin" ],
      svg: <GlobeSvg/>
   },
   {
      path: Paths.DocumentTypes,
      title: "Rodzaje dokumentów",
      allowed_role: [ "admin" ],
      svg: <NoteSvg/>
   },
   {
      path: Paths.Documents.Start,
      title: "Wyniki wyszukiwania",
      svg: <TargetSvg/>
   },
   {
      path: Paths.MessageTemplates,
      title: "Wzory wiadomości",
      allowed_role: [ "admin" ],
      svg: <EditSvg/>
   },
   {
      path: Paths.CorrespondenceWithUnits,
      title: "Korespondencja z jednostkami",
      svg: <DeviceMessageSvg/>
   },
   {
      group: "Inne"
   },
   {
      path: Paths.FileArchives,
      title: "Paczki plików",
      svg: <DocumentCopySvg/>
   },
   {
      path: Paths.Users,
      title: "Użytkownicy",
      allowed_role: [ "admin" ],
      svg: <UserGroupSvg/>
   },
   {
      path: "",
      title: "Ustawienia profilu",
      svg: <SettingSvg/>
   },
   {
      path: "",
      title: "Wyloguj się",
      svg: <LogoutSvg/>
   }
]
